import { ECalculatorEvent } from 'shared/constants/calculatorEvents';

let calculatorMicrofrontendElement: HTMLElement | null = null;

export const setCalculatorMicrofrontendElement = (element: HTMLElement | null): void => {
  calculatorMicrofrontendElement = element;
};

export const getCalculatorMicrofrontendElement = (): HTMLElement | null => calculatorMicrofrontendElement;

const dispatchResetOnElement = (element: HTMLElement): void => {
  element.dispatchEvent(new CustomEvent(ECalculatorEvent.onReset, { bubbles: true, composed: true }));
};

export const dispatchCalculatorResetEvent = (): boolean => {
  if (!calculatorMicrofrontendElement) {
    return false;
  }

  const form = calculatorMicrofrontendElement.querySelector('form');
  const target = form instanceof HTMLFormElement ? form : calculatorMicrofrontendElement;

  dispatchResetOnElement(target);

  return true;
};
